import _ from "lodash";
import { ajax } from "../../app/core/ajax";
import * as z from "../../framework";
import { popUp } from "../controls/popUp";
import { alert } from "../core/alert";
import { errorAlert } from "../core/errorAlert";
import { ll } from "../core/ll";

function getActualTimesOnOrder(orderLineId: number): JQueryDeferred<number[]> {
    let promise = $.Deferred() as JQueryDeferred<any[]>,
        filter = `$filter=ActualOrderLineId eq ${orderLineId}`;

    const top = `$top=10000`,
        select = `$select=Id`;

    z.ajax({
        url: `ActualTime?${filter}&${top}&${select}`
    }).done(function (response) {
        let results = response.d.results,
            actualTimeIds = _.map(results, actualTime => actualTime.Id);

        promise.resolve(actualTimeIds);
    }).fail(function () {
        promise.resolve([]);
    });

    return promise;
}

function sendActualTimeDelete(id: number): JQueryDeferred<any> {
    let promise = $.Deferred();

    ajax({
        type: "DELETE",
        url: `ActualTime/${id}`,
        errorHandled: true,
    }).done(function () {
        promise.resolve();
    }).fail(function (response) {
        errorAlert({
            response: response
        });

        promise.reject();
    });

    return promise;
}

function sendOrderLineDelete(id: number): JQueryDeferred<any> {
    let promise = $.Deferred();

    ajax({
        type: "DELETE",
        url: `OrderLine/${id}?checkDelete=false`,
        errorHandled: true,
    }).done(function () {
        alert({
            header: ll("DeleteSuccess"),
            message: ll("DeleteSuccessMessage").format(ll("OrderLine")),
            type: "success"
        });

        promise.resolve();
    }).fail(function (response) {
        errorAlert({
            response: response
        });

        promise.reject();
    });

    return promise;
}

export async function deleteOrderLine(orderLineId: number) {
    const actualTimeIds = await getActualTimesOnOrder(orderLineId),
        multipleActualTimes = actualTimeIds.length > 0,
        buttons = [
            {
                name: ll("DeleteTitle").format(ll("OrderLine")),
                id: "DeleteOrderLine",
                clickEvent: async e => {
                    e.preventDefault();

                    disableButtons();
                    deleteOrderLinePopUp.get(".WarningMessage").addClass("hidden");
                    deleteOrderLinePopUp.get(".progress").removeClass("hidden");

                    let orderLineLL = ll("OrderLine"),
                        deletingMessage = ll("DeletingEntity").format(orderLineLL);
                    $("#ProgressMessage").text(deletingMessage);

                    await sendOrderLineDelete(orderLineId);
                    closePopup();
                }
            }
        ];

    if (multipleActualTimes) {
        buttons.push({
            name: ll("DeleteOrderLineAndActualTimes"),
            id: "DeleteActualTimes",
            clickEvent: async e => {
                e.preventDefault();

                disableButtons();
                deleteOrderLinePopUp.get(".WarningMessage").addClass("hidden");
                deleteOrderLinePopUp.get(".progress").removeClass("hidden");
                let progressMessageElement = $("#ProgressMessage"),
                    actualTimeLL = ll("ActualTime");

                // for loop required here since lodash does not allow async
                for (let index = 0; index < actualTimeIds.length; index++) {
                    let message = ll("DeletingNumberOf").format(actualTimeLL, index + 1, actualTimeIds.length);
                    progressMessageElement.text(message);

                    let actualTimeId = actualTimeIds[index];
                    await sendActualTimeDelete(actualTimeId);
                }

                let orderLineLL = ll("OrderLine"),
                    deletingMessage = ll("DeletingEntity").format(orderLineLL);
                progressMessageElement.text(deletingMessage);

                await sendOrderLineDelete(orderLineId);
                closePopup();
            }
        });
    }

    buttons.push({
        name: ll("Cancel"),
        id: "DeleteOrderLineCancel",
        clickEvent: async () => { }
    });

    let popupMessage = multipleActualTimes
        ? ll("DeleteOrderLineWithActualTimes").format(actualTimeIds.length)
        : ll("DeleteMessage").format(ll("OrderLine"));

    const deleteOrderLinePopUp = popUp({
        id: "DeleteOrderLinePopUp",
        title: ll("DeleteTitle").format(ll("OrderLine")),
        guts: `
                <span class="WarningMessage">${popupMessage}</span>
                <div class='hidden progress progress-striped active loading-bar auto-schedule-services-progress-bar' >
                    <span id='ProgressMessage' class='loading-bar-message'></span>
                    <div id='ProgressBar' class='progress-bar' role='progressbar' style='width: 100%'></div>
                </div>
              `,
        width: 650,
        keepContentBox: true,
        buttons: buttons
    });

    let disableButtons = function () {
        const buttonSelectors = [
            "#DeleteOrderLine",
            "#DeleteActualTimes",
            "#DeleteOrderLineCancel"
        ];

        _.each(buttonSelectors, function (buttonSelector) {
            let element = deleteOrderLinePopUp.get(buttonSelector);

            element.disable();
            element.blur();
        });
    };

    let closePopup = function () {
        deleteOrderLinePopUp.window.close();
        $("#OrderLines").data("me").refresh();
    };
}
